import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/theme.css';
import Login        from './pages/Login/Login';
import Dashboard    from './pages/Dashboard/Dashboard';
import CreateMeeting from './pages/CreateMeeting/CreateMeeting';
import JoinMeeting  from './pages/JoinMeeting/JoinMeeting';
import History      from './pages/History/History';
import Settings     from './pages/Settings/Settings';
import PageNotFound from './pages/PageNotFound/PageNotFound';

const RequireAuth = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

const RequireAdmin = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const role = localStorage.getItem('loginRole');
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (role !== 'admin') return <Navigate to="/join" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login"     element={<Login />} />
        <Route path="/"          element={<RequireAdmin><Dashboard /></RequireAdmin>} />
        <Route path="/home"      element={<RequireAdmin><Dashboard /></RequireAdmin>} />
        <Route path="/create"    element={<RequireAdmin><CreateMeeting /></RequireAdmin>} />
        <Route path="/join"      element={<RequireAuth><JoinMeeting /></RequireAuth>} />
        <Route path="/history"   element={<RequireAdmin><History /></RequireAdmin>} />
        <Route path="/settings"  element={<RequireAdmin><Settings /></RequireAdmin>} />
        <Route path="*"          element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
